/**
 * String constants for EDMS Document Types page.
 */

export const PAGE = {
  title: 'Document Types',
  description:
    'Manage Document Types used in the document management system. Use the filters below to refine the list.',
};

export const ACTIONS = {
  create: 'Create Document Type',
  edit: 'Update Document Type',
  delete: 'Delete Document Type',
  cancel: 'Cancel',
};

export const SEARCH = {
  placeholder: 'Search document types…',
  inputId: 'document-type-search',
};

export const ACTIVE_FILTER = {
  selectId: 'document-type-active',
};

export const MESSAGES = {
  createSuccess: 'Document Type created successfully.',
  createError: 'Unable to create Document Type. Please try again.',
  updateSuccess: 'Document Type updated successfully.',
  updateError: 'Unable to update Document Type. Please try again.',
  updateMissingId: 'Unable to update Document Type: missing Document Type identifier.',
  deleteSuccess: 'Document Type deleted successfully.',
  deleteError: 'Unable to delete Document Type. Please try again.',
};

export const CONFIRM = {
  updateTitle: 'Update Document Type?',
  updateMessage: 'Apply the pending changes?',
  deleteTitle: 'Delete Document Type?',
  deleteMessage: (name) =>
    `This will remove "${name || 'this Document Type'}" and any linked records. This action cannot be undone.`,
};

export const SUCCESS_DIALOG = {
  successTitle: 'Success',
  errorTitle: 'Action required',
};
